export const ENTITY_TAB_CATEGORIES_DEFAULT_QA_NAME = {
  editCategories: 'entityTabCategoriesEdit',
  table: 'entityTabCategories',
}

export const ENTITY_TAB_CATEGORIES_SCALAR_SCOPE_FILTER_KEYS = ['staff_member']
